import { Link } from "react-router-dom";

type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, idx) => {
          const last = idx === items.length - 1;
          return (
            <li key={idx} className="flex items-center gap-1.5">
              {item.to && !last ? (
                <Link to={item.to} className="text-foreground-600 transition-colors hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span aria-current={last ? "page" : undefined} className="text-foreground-800">
                  {item.label}
                </span>
              )}
              {!last && <i className="ri-arrow-right-s-line" aria-hidden="true"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}